// extracted by mini-css-extract-plugin
module.exports = {"mdNote":"ModalNotes_mdNote__2W4j8","modalFooterButton":"ModalNotes_modalFooterButton__2UD2D"};